/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeadPreview/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LeadPreview({
  children,
  viewPath = "/DesignSystem/LeadPreview",
  handleClose,
  hideActions,
  showNextActions,
  onClickNextAction,
  onClickPrevAction,
  prevActionDisabled,
  nextActionDisabled
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Empty'}>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
 handleClose={handleClose}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 hideActions={hideActions}
 showNextActions={showNextActions}
 onClickNextAction={onClickNextAction}
 onClickPrevAction={onClickPrevAction}
 handleClose={handleClose}
 prevActionDisabled={prevActionDisabled}
 nextActionDisabled={nextActionDisabled}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}